import SaleUtils from '@/services/SaleUtils'
import { required } from "@/services/validations"
/* models */
import WhUnitMeasurement from '@/models/Warehouse/WhUnitOfMeasurement'
// Fields to Comercial Information
export default [
    {
      name: 'minimum_stock',
      type: 'currency-field',
      flex: {
        sm6: true,
        lg3: true,
      },
      props: {
          label: 'Mínimo stock',
          rules: [required],
          suffix: '',
         
      },
    },
    {
      name: 'maximum_stock',
      format: 'currency',
      type: 'currency-field',
      flex: {
        sm6: true,
        lg3: true,
      },
      props: {
          label: 'Maximo stock',
          rules: [required],
          suffix: '',
      },
    },
    {
      name: 'critical_stock',
      type: 'currency-field',
      props: {
          label: 'Stock critico',
          rules: [required],
          suffix: '',
          
      },
      rules: [],
      // computed: ({ sale_price }) => {
      //     return '$' + SaleUtils.getNetPrice(sale_price)
      // },
    },
    // {
    //   props: {title:''},
    //   type: 'section-field',
    //   flex: {
    //     xs12: true,
    //   },
    // },
    // {
    //   name: "wh_unit_of_measurement_id",
    //   type: "autocomplete-model",
    //   flex: {
    //       sm6: true,
    //       lg3: true,
    //   },
    //   props: {
    //       chips: true,
    //       itemText: "name",
    //       itemValue: "id",
    //       label: "Unidad de medida",
    //       model: WhUnitMeasurement,
    //       noObject: true,
    //       paramSearch: "name",
    //       rules: [ required ],
    //   },
    // },
    // {
    //     //comercial fields[2] - Margen
    //     name: 'uom_quantity',
    //     type: 'currency-field',
    //     props: {
    //       label: 'Cantidad Minima(U.M)',
    //       rules: [ required ],
    //       suffix: '',
    //     },
    //     // computed: ({ sale_price, cost_price }) =>
    //     //     SaleUtils.getNewMargin(sale_price, cost_price),
    //     // value: 0,
    // },
    {
      props: {title:''},
      type: 'section-field',
      flex: {
        xs12: true,
      },
    },
    // {
    //     name: 'have_decimal_quantity',
    //     type: 'checkbox',
    //     props: {
    //         label: 'Cantidad Decimal',
    //         'false-value': false,
    //     },
    //     value: false,
    // },
    {
      name: 'is_repackaged',
      type: 'checkbox',
      props: {
          label: 'Producto Envasado',
      },
      value: false,
    },
    // {
    //   name: 'is_inventoriable',
    //   type: 'checkbox',
    //   props: {
    //       label: 'Producto Inventariable',
    //       'false-value': false,
    //   },
    //   value: false,
    // },
    {
      name: 'is_seasonal',
      type: 'checkbox',
      props: {
          label: 'Producto Temporada',
          'false-value': false,
      },
      value: false,
    },
]
